import { render, staticRenderFns } from "./notes_page.vue?vue&type=template&id=510eb128&scoped=true&"
import script from "./notes_page.vue?vue&type=script&lang=js&"
export * from "./notes_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510eb128",
  null
  
)

export default component.exports